import React from 'react';
import {
  SUBMITTER_CERTIFICATION_TITLE,
  WE_AGREE_LABEL,
  submitterCertificationParagraphs,
  type SubmitterCertificationForm,
} from '../../../constants/tmhpFormText';

interface SubmitterCertificationSectionProps {
  formCode: SubmitterCertificationForm;
  data: Record<string, unknown>;
  onChange: (field: 'submitterAgreed' | 'submitterName' | 'submitterTitle' | 'submitterDate', value: string | boolean) => void;
  isReadOnly?: boolean;
}

const inputClass =
  'w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-slate-500 text-sm text-left';
const labelClass = 'block text-sm font-medium text-gray-700 mb-1 text-left';

/**
 * TMHP "Prior Authorization Request Submitter Certification Statement" (page 1 of F00012,
 * F00028, F00120 and F00070), shown read-only and word for word, with the "We Agree" box.
 * Submitter name / title / date are agency fields (the official form has the box only).
 */
const SubmitterCertificationSection: React.FC<SubmitterCertificationSectionProps> = ({ formCode, data, onChange, isReadOnly = false }) => (
  <div className="rounded-lg border border-slate-300 bg-white shadow-sm mb-4 p-4" data-testid="submitter-certification">
    <h4 className="text-base font-semibold text-gray-900 text-left mb-2">{SUBMITTER_CERTIFICATION_TITLE}</h4>
    <div className="space-y-2 text-xs text-gray-700 text-left max-h-64 overflow-y-auto border border-slate-200 rounded p-3 bg-slate-50">
      {submitterCertificationParagraphs(formCode).map(paragraph => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
    <label className="flex items-center gap-2 mt-3 text-sm font-semibold text-gray-800">
      <input
        type="checkbox"
        checked={data.submitterAgreed === true}
        onChange={e => onChange('submitterAgreed', e.target.checked)}
        disabled={isReadOnly}
        className="rounded border-gray-300"
      />
      {WE_AGREE_LABEL}
    </label>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
      <div>
        <label className={labelClass} htmlFor={`${formCode}-submitterName`}>Submitter name</label>
        <input id={`${formCode}-submitterName`} type="text" value={String(data.submitterName ?? '')} onChange={e => onChange('submitterName', e.target.value)} readOnly={isReadOnly} className={inputClass} />
      </div>
      <div>
        <label className={labelClass} htmlFor={`${formCode}-submitterTitle`}>Title</label>
        <input id={`${formCode}-submitterTitle`} type="text" value={String(data.submitterTitle ?? '')} onChange={e => onChange('submitterTitle', e.target.value)} readOnly={isReadOnly} className={inputClass} />
      </div>
      <div>
        <label className={labelClass} htmlFor={`${formCode}-submitterDate`}>Date</label>
        <input id={`${formCode}-submitterDate`} type="date" value={String(data.submitterDate ?? '')} onChange={e => onChange('submitterDate', e.target.value)} readOnly={isReadOnly} className={inputClass} />
      </div>
    </div>
  </div>
);

export default SubmitterCertificationSection;
